import React, { useContext, useMemo } from 'react';
const FixtureSelectContext = React.createContext({
    selectFixture: () => { },
});
export function FixtureSelectProvider(props) {
    const value = useMemo(() => ({ selectFixture: props.onSelect }), [props.onSelect]);
    return (React.createElement(FixtureSelectContext.Provider, { value: value }, props.children));
}
export function useFixtureSelect() {
    return useContext(FixtureSelectContext);
}
